import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mirror",
  "use": "icon-mirror-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mirror\"><path d=\"M928 896H546.304V128zM97.92 896h381.44V128L97.92 896z m334.08-49.92H170.24l261.76-518.4v518.4z\" p-id=\"8845\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol